import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";

import { BID_ACCOUNT_ROUTE, TURN_ORACLE_CRANK_ROUTE } from "../constants";
import { abfSerializeQueryArgs, oracleBaseQuery } from "./util";
import { BidAccount, TurnOracleParams } from "../types";

const ORACLE_PRICES = "OraclePrices";
export const oraclePricesApi = createApi({
    reducerPath: "oraclePricesApi",
    baseQuery: oracleBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    tagTypes: [ORACLE_PRICES],
    endpoints: (builder) => ({
        loanBidAccount: builder.query<BidAccount | null, string>({
            query(loanAddress) {
                return {
                    url: `${BID_ACCOUNT_ROUTE}/${loanAddress}`,
                    method: "GET"
                };
            }
        }),
        turnOracle: builder.mutation<void, TurnOracleParams>({
            invalidatesTags: [ORACLE_PRICES],
            query(params) {
                return {
                    url: TURN_ORACLE_CRANK_ROUTE,
                    body: params,
                    method: "POST"
                };
            }
        })
    })
});

export const { useLoanBidAccountQuery, useTurnOracleMutation } = oraclePricesApi;

export function useOraclePricesApi() {
    const dispatch = useDispatch();

    return {
        resetOraclePricesApi: () => dispatch(oraclePricesApi.util.invalidateTags([ORACLE_PRICES]))
    };
}
